import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center pdb-20" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Participants")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchParticipantsFilters = _resolveComponent("SearchParticipantsFilters")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SearchParticipantsList = _resolveComponent("SearchParticipantsList")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SearchParticipantsFilters, {
      filters: $setup.filters,
      searching: $setup.loading,
      onUpdateFilters: $setup.updateFilters
    }, null, 8, ["filters", "searching", "onUpdateFilters"]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_SearchParticipantsList, { persons: $setup.persons }, null, 8, ["persons"]),
          _createVNode(_component_PaginationComponent, {
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"])
        ], 64))
  ]))
}